// @flow
import * as React from 'react';
import {HiOutlineChevronRight} from "react-icons/hi";
import {PiShoppingCartFill} from "react-icons/pi";
import {useCart} from "../context/CartContext";
import {useNavigate} from "react-router-dom";


export default function Header(props) {
    let BG = props.transparent ?'bg-transparent' : 'bg-white';
    const navigate = useNavigate();
    const { cart } = useCart();
    return (
        <React.Fragment>
            <header className={"navbar px-2 navbar-dark bd-navbar actionbar rtl fixed-top max-w-lg text-center " + BG}>

                <div className="w-100 float-right text-big-1 ">
                    &nbsp;
                    {props.title?.substring(0, 25)}
                    {
                        props.title?.length > 25 ?
                            <span className='text-small-4'>
                                                    ...
                                                </span>
                            : ''
                    }
                    <span className='text-small-2 text-muted float-start'>
                    {cart.length > 0 && (
                        <span
                            className='badge bg-third-color text-white position-relative top-0 translate-middle rounded-pill small'>
                   {cart.length}
                </span>
                    )}
                        <PiShoppingCartFill className=' text-big-5  text-primary-color' onClick={() => {
                            navigate('/cart')
                        }}/>

                </span>
                </div>

                {
                    props.hasBack &&
                    <div className="position-absolute" onClick={() => {
                        props.backAddress ? window.location.replace(props.backAddress) : window.history.length > 1 ? window.history.back() : window.location.replace("/")
                    }}>
                        <HiOutlineChevronRight className='text-big-5 '/>
                    </div>
                }

            </header>
        </React.Fragment>
    );
};